import * as React from 'react';
import { Question } from 'survey-core';
import { SurveyQuestionElementBase } from 'survey-react-ui';
import { CountriesListContainer } from '../../containers/CountriesListContainer';
import { get } from 'lodash';
import { Model } from 'survey-core/survey.core';
import { ICountry } from '../../types/companyDetails';
import { CompanyLocation } from '../../types/enums';

export const TYPE = 'mui-countries';
export const SELECTED_COUNTRY_STATE_KEY = 'signup:selectedCountry';

const providedCountry = {
  AU: {
    iso2: 'AU',
    name: 'Australia'
  },
  GB: {
    iso2: 'GB',
    name: 'United Kingdom'
  }
};

export class MuiCountriesModel extends Question {
  getType(): string {
    return TYPE;
  }

  get strings() {
    return this.getPropertyValue('strings');
  }
  set strings(val) {
    this.setPropertyValue('strings', val);
  }
}

export class MuiCountries extends SurveyQuestionElementBase {
  constructor(props: any) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    const model = this.question.survey as Model;
    model.setVariable('savedCountry', this.getSelectedCountry());
  }

  get question() {
    return this.questionBase;
  }

  getString(key: string) {
    return get(this.question, ['strings', key], key);
  }

  getSelectedCountry() {
    try {
      const item = sessionStorage.getItem(SELECTED_COUNTRY_STATE_KEY);

      if (item) return JSON.parse(item);

      switch (this.question.value) {
        case CompanyLocation.AU:
          return providedCountry.AU;
        case CompanyLocation.GB:
          return providedCountry.GB;
        default:
          return null;
      }
    } catch {
      return null;
    }
  }
  handleInputChange(value: string) {
    this.question.value = value;
  }

  handleBlur({ target: { value } }: React.FocusEvent<HTMLInputElement>) {
    const model = this.question.survey as Model;
    const savedCountry = model.getVariable('savedCountry');

    this.question.value = savedCountry?.name === value ? savedCountry?.iso2 : null;
  }

  handleSelect(value: string, savedCountry: ICountry, forceUpdate = false) {
    const model = this.question.survey as Model;
    const relatedQuestions = model.getQuestionsByNames(['address1', 'address2', 'townOrCity', 'postalCode']);

    if (value !== this.question.value) {
      relatedQuestions.forEach(question => {
        question.clearValue();
        question.clearErrors();
      });
    }

    this.question.value = savedCountry.iso2;
    model.setVariable('savedCountry', savedCountry);
    sessionStorage.setItem(SELECTED_COUNTRY_STATE_KEY, JSON.stringify(savedCountry));

    forceUpdate && this.question.setPropertyValue('forceUpdated', Date.now());
  }

  protected renderElement(): JSX.Element | null {
    const model = this.question.survey as Model;
    const { value = '', title, name, isRequired, errors, readOnly } = this.question;
    const savedCountry = model.getVariable('savedCountry') || this.getSelectedCountry();

    return (
      <CountriesListContainer
        value={value}
        title={title}
        name={name}
        isRequired={isRequired}
        errors={errors}
        onSelectOption={this.handleSelect}
        disabled={readOnly}
        onChange={this.handleInputChange}
        onBlur={this.handleBlur}
        savedCountry={savedCountry}
      />
    );
  }
}
